import { AttributablePay } from '@fora-monorepo/employer-my-pages-common/types';
import { stringToNumberOrNull } from '@fora-monorepo/string-utils';
import { ValidationResult, ValidationRule } from '@foradevelopment/fora-ui';

import { isPayAmountSameOrLargerThanAttributableTotal } from '../../isPayAmountSameOrLargerThanAttributableTotal';

export const isPayLargerThanAttributableTotal =
  (errorMessage: string, attributablePay: AttributablePay | undefined): ValidationRule =>
  (inputToValidate: string): ValidationResult => {
    if (!attributablePay || attributablePay.length === 0) {
      return { error: false, errorMessage };
    }
    if (!isPayAmountSameOrLargerThanAttributableTotal(stringToNumberOrNull(inputToValidate), attributablePay)) {
      return { error: true, errorMessage };
    }
    return { error: false, errorMessage };
  };
